export default "__VITE_ASSET__D308VloW__"